import { useEffect, useRef, useState } from "react";

const FRAGMENTS = [
  { l: "SOURCE 014", x: 15, y: 22 }, { l: "LEGAL FRAMEWORK", x: 72, y: 18 },
  { l: "CROSS-BORDER STRUCTURE", x: 25, y: 68 }, { l: "FINANCIAL FLOW", x: 65, y: 74 },
  { l: "OPEN SOURCE", x: 8, y: 46 }, { l: "RESEARCH NOTE", x: 82, y: 44 },
  { l: "JURISDICTION", x: 45, y: 12 }, { l: "PUBLIC REPORT", x: 40, y: 82 },
];
const NODES = Array.from({ length: 14 }, (_, i) => ({
  cx: 5 + (i * 7) % 90, cy: 10 + (i * 13) % 78, r: 1.5 + (i % 3),
}));

export default function InvestigativeScene() {
  const ref = useRef(null);
  const [reduced, setReduced] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const h = () => setReduced(mq.matches);
    mq.addEventListener?.("change", h);
    return () => mq.removeEventListener?.("change", h);
  }, []);

  useEffect(() => {
    if (reduced) return;
    const el = ref.current; if (!el) return;
    let raf, tx = 0, ty = 0, cx = 0, cy = 0;
    const planes = el.querySelectorAll("[data-plane]");
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
    };
    const loop = () => {
      cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
      planes.forEach((p) => {
        const d = parseFloat(p.dataset.plane || "0");
        p.style.transform = `translate3d(${-cx * d}px, ${-cy * d}px, 0)`;
      });
      raf = requestAnimationFrame(loop);
    };
    loop();
    el.addEventListener("mousemove", onMove);
    return () => { cancelAnimationFrame(raf); el.removeEventListener("mousemove", onMove); };
  }, [reduced]);

  useEffect(() => {
    if (reduced) return;
    const id = setInterval(() => setTick((t) => t + 1), 6500 + Math.random() * 5000);
    return () => clearInterval(id);
  }, [reduced]);

  const active = tick % FRAGMENTS.length;

  return (
    <div ref={ref} className="absolute inset-0 scene-3d overflow-hidden pointer-events-none" data-testid="investigative-scene" aria-hidden="true">
      <div className="plane" data-plane="3">
        <svg viewBox="0 0 800 500" className="w-full h-full opacity-[0.14]" preserveAspectRatio="xMidYMid slice">
          <g stroke="#84929F" strokeWidth="0.3" fill="none">
            <path d="M50 250 Q200 150 380 220 T760 180" />
            <path d="M20 320 Q150 380 320 340 T780 300" />
            <path d="M100 100 Q300 60 500 140 T780 110" />
            <path d="M60 400 Q220 440 400 410 T770 420" />
          </g>
          <g fill="#84929F" opacity="0.6">
            {NODES.map((n, i) => (
              <circle key={i} cx={n.cx * 8} cy={n.cy * 5} r={n.r * 0.5} className={i === active % NODES.length ? "pulse-node" : ""} />
            ))}
          </g>
        </svg>
      </div>
      <div className="plane" data-plane="7" key={`net-${tick}`}>
        <svg viewBox="0 0 800 500" className="w-full h-full" preserveAspectRatio="xMidYMid slice">
          <path className="trace-crimson" d="M120 100 Q250 200 380 130 T620 220" />
          <path className="trace-crimson" d="M200 400 Q320 350 480 380 T700 320" />
          <path className="trace-cyan" d="M180 250 Q320 180 460 260 T720 180" />
          <path className="trace-cyan" d="M100 350 Q220 380 360 340" />
        </svg>
      </div>
      <div className="plane" data-plane="14">
        {FRAGMENTS.map((f, i) => (
          <div key={f.l}
            className={`absolute font-mono text-[10px] tracking-widest border rounded-sm px-2 py-1 backdrop-blur-sm transition-all duration-700 ${
              i === active ? "text-white border-white/40 bg-obsidian-soft/80 shadow-[0_0_20px_rgba(0,212,255,0.35)]"
                            : "text-white/50 border-white/10 bg-obsidian-soft/40"}`}
            style={{ left: `${f.x}%`, top: `${f.y}%` }}>{f.l}</div>
        ))}
      </div>
    </div>
  );
}
